import { configureStore } from "@reduxjs/toolkit";
import accessReducer from "../features/access/accessSlice";
import assistantReducer from "../features/assistant/assistantSlice";
import authReducer from "../features/auth/authSlice";
import dashboardReducer from "../features/dashboard/dashboardSlice";
import inventoryRevisionsReducer from "../features/inventoryRevisions/inventoryRevisionsSlice";
import onlineSellerReducer from "../features/onlineSeller/onlineSellerSlice";
import categoriesReducer from "../features/categories/categoriesSlice";
import productsReducer from "../features/products/productsSlice";
import purchaseRequestsReducer from "../features/purchaseRequests/purchaseRequestsSlice";
import reportsReducer from "../features/reports/reportsSlice";
import returnsReducer from "../features/returns/returnsSlice";
import stockTransfersReducer from "../features/stockTransfers/stockTransfersSlice";
import storesReducer from "../features/stores/storesSlice";
import storeSalesReducer from "../features/storeSales/storeSalesSlice";
import inventoryReducer from "../features/inventory/inventorySlice";
import stockOverviewReducer from "../features/stockOverview/stockOverviewSlice";
import uiReducer from "../features/ui/uiSlice";
import wholesaleReducer from "../features/wholesale/wholesaleSlice";

export const store = configureStore({
  reducer: {
    access: accessReducer,
    assistant: assistantReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    inventoryRevisions: inventoryRevisionsReducer,
    onlineSeller: onlineSellerReducer,
    categories: categoriesReducer,
    products: productsReducer,
    purchaseRequests: purchaseRequestsReducer,
    reports: reportsReducer,
    returns: returnsReducer,
    stockTransfers: stockTransfersReducer,
    stores: storesReducer,
    storeSales: storeSalesReducer,
    inventory: inventoryReducer,
    stockOverview: stockOverviewReducer,
    ui: uiReducer,
    wholesale: wholesaleReducer,
  },
  // thunk is enabled by default in Redux Toolkit middleware
});


